import React from 'react';
import PropTypes from 'prop-types';
import Styled from './styled';
import Copyable from '$app/shared/components/Copyable';

const Note = ({ title, note }) => (
  <Styled className="note-wrapper">
    <h3>{title}</h3>
    <div className="note-content">
      <p>&ldquo;{note}&rdquo;</p>
      <Copyable value={note} />
    </div>
  </Styled>
);

Note.propTypes = {
  title: PropTypes.string,
  note: PropTypes.string,
};

Note.defaultProps = {
  title: 'For the mechanic:',
  note: '',
};

export default Note;
